import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';

@Injectable({
  providedIn: 'root'
})
export class ApiAttributesGroupsService {

  constructor(
    private apiBasic: ApiBasicService
  ) { }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
   getReferences(params: any, moduleName): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'attributes_groups');
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
   info(id: string): Observable<Res> {

    return this.apiBasic.getInfo('attributes_groups', id);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  create(params: any): Observable<Res> {

    return this.apiBasic.create('attributes_groups', params);
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
   edit(id: string): Observable<Res> {

    return this.apiBasic.edit('attributes_groups', id);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
   update(params: any): Observable<Res> {

    return this.apiBasic.update('attributes_groups', params);
  }

  /**
   * 
   */
   delete(params: any): Observable<Res> {

    return this.apiBasic.delete('attributes_groups', params);
  }
}
